import {lazy} from 'react';

export const BranchDetailPageRedirectionLazy = lazy(() => import(/* webpackChunkName: "BranchDetailPageRedirection" */ '.'));
